/* eslint-disable */
import { FormEditFieldCreateDialogView, FormEditFieldDialogViewFactory, FormEditFieldUpdateDialogView, } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector, } from '@angular/core';
import { FormEditCreateUpdateEmailAddressFieldDialogComponent } from '../../admin/form/form-edit/dialogs/fields/emailaddress/create-update/form-edit-create-update-emailaddress-field-dialog.component';
/* eslint-enable */

/**
 * EmailAddress field implementation.
 */
export class FormEditEmailAddressFieldDialogViewFactory implements FormEditFieldDialogViewFactory {

  constructor(private injector: Injector,
              private cfr: ComponentFactoryResolver) {
  }

  createCreateView(): ComponentRef<FormEditFieldCreateDialogView> {
    return this.createView();
  }

  createUpdateView(): ComponentRef<FormEditFieldUpdateDialogView> {
    return this.createView();
  }

  private createView(): ComponentRef<FormEditCreateUpdateEmailAddressFieldDialogComponent> {
    return this.cfr.resolveComponentFactory(FormEditCreateUpdateEmailAddressFieldDialogComponent)
      .create(this.injector);
  }

}
